import clsx from 'clsx';
import styles from './Stat.module.css';

/** Card de métrica: valor grande (Oswald) + label mono. `tone` colore o valor. */
export default function Stat({ value, label, tone = 'hi', icon, className }) {
  return (
    <div className={clsx(styles.stat, className)}>
      <div className={styles.head}>
        <span className={clsx(styles.value, styles[`tone-${tone}`])}>{value}</span>
        {icon && <span className={styles.icon}>{icon}</span>}
      </div>
      <div className={styles.label}>{label}</div>
    </div>
  );
}
